import simpleWork from "./simpleWork";
import workspaceStatus from "./workspaceStatus";
// Zentrale Uebersetzungs-Map: Schluessel = deutscher UI-Text, Wert = { fr, it, en }.
// Nicht uebersetzte Strings fallen sauber auf Deutsch (den Schluessel) zurueck.
import common from "./common";
import cockpit from "./cockpit";
import admin from "./admin";
import admin2 from "./admin2";
import pub from "./public";
import backup from "./backup";
import security from "./security";
import security2 from "./security2";
import support2 from "./support2";
import cockpit2 from "./cockpit2";
import cockpit3 from "./cockpit3";
import cockpitOverview from "./cockpit_overview";
import documents from "./documents";
import notifications from "./notifications";
import aiAssist from "./ai_assist";
import onboarding from "./onboarding";
import pwa from "./pwa";
import websiteProduction from "./website_production";
import pcProduction from "./pc_production";

export const TR = { ...pcProduction, ...simpleWork, ...websiteProduction, ...cockpitOverview, ...support2, ...cockpit2, ...cockpit3, ...documents, ...notifications, ...aiAssist, ...onboarding, ...pwa, ...common, ...cockpit, ...admin, ...admin2, ...pub, ...backup, ...security, ...security2, ...workspaceStatus };
export default TR;

